import { styled, TableCell } from "@mui/material";

export const HeaderCell = styled(TableCell)({
  fontSize: "13px",
  fontWeight: 600,
  color: "#071F35",
  whiteSpace: "nowrap",
  backgroundColor: "rgba(246, 248, 252, 1)",
  borderBottom: "1px solid #DBE8F5",
  padding: "6px 10px",
  position: "sticky",
  top: 0,
  zIndex: 2
});

export const FixedHeaderCell = styled(HeaderCell)({
  zIndex: 3
});

export const BodyCell = styled(TableCell)({
  fontSize: "13px",
  color: "#071F35",
  borderBottom: "1px solid #EDF2F7",
  whiteSpace: "nowrap",
  padding: "6px 10px"
});
